<template>

    <div class="col-md-8 offset-md-2">
      <ValidationObserver ref="observer" v-slot="{invalid, passes }">
        <form @submit.prevent="submit(passes)">
          <div class="form-group">
            <label for="surname">
              Name
              <span class="text-danger">*</span>
            </label>
            <validation-provider name="name" rules="required" v-slot="{ errors }">
              <input
                class="form-control input-sm"
                placeholder="Enter Name"
                v-model="form.name"
                type="text"
              />
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="email">
              Email/Phone
              <span class="text-danger">*</span>
            </label>
            <input
              class="form-control input-sm"
              v-model="userInfo"
              readonly
              type="text"
            />
          </div>
          <template v-if="form.email">
          <div class="form-group">
            <label for="Password">Password</label>
            <validation-provider name="Password" rules="min:8" vid="password" v-slot="{ errors }">
              <input
                class="form-control input-sm"
                placeholder="Enter Password"
                v-model="form.password"
                type="password"
              />
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="form-group">
            <label for="Password Confirmation">Password Confirmation</label>

            <validation-provider
              name="Password Confirmation"
              rules="confirmed:password"
              v-slot="{ errors }"
            >
              <input
                class="form-control input-sm"
                placeholder="Enter Password Confirmation"
                v-model="form.password_confirmation"
                type="password"
              />
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </template>
          <ValidationProvider rules="image" name="imageUrl" v-slot="{ validate, errors }">
            <div class="text-center">
              <img
              @click="choosePassPic"
              style="display:block;cursor:pointer; margin: 0 auto;"
                id="imageUrl"
                :src="getImg(form.imageUrl)" 
                width="150"
                height="auto"
                alt="no image"
              />
              <input
                @change="validate"
                class="custom-file-input"
                ref="filePic"
                type="file"
                @input="readPassPicURL"
              />
            </div>

            <span class="text-danger text-center">{{ errors[0] }}</span>
          </ValidationProvider>
          <button
          
            :disabled="invalid || loading"
            type="submit"
            class="mb-5 btn btn-warning btn-block btn-flat"
          >{{loading? 'Loading...' : 'Update Profile'}}</button>
        </form>
      </ValidationObserver>
    </div>
</template>

<script type="text/ecmascript-6">
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import  imageSelect from "@/plugins/mixins/imageSelect";
import { UPDATE_PROFILE } from "@/store/action-types";

function getDefaultData() {
  return {
    form: {
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
      imageUrl: ''
    }
  };
}

export default {
  name: "Profile",
  components: {
    ValidationObserver,
    ValidationProvider
  },

    computed:{
      ... mapState({
    errors: (state) => state.errors,
    loading: (state) => state.loading,
    onLine: (state) => state.auth.onLine,
  }),

  userInfo() {
      return this.authUser.email || this.authUser.phone;
    },
},

  mixins: [imageSelect],

  data() {
    return {
      pageTitle: "Profile",

      ...getDefaultData()
    };
  },


  methods: {
    submit() {
      this.$store
        .dispatch(UPDATE_PROFILE, this.form)
        .then(() => {
            requestAnimationFrame(() => {
            this.$refs.observer.reset();
          });
        })
        .catch(() => {
          this.$refs.observer.setErrors(this.errors);
        });
    },

       getImg(url) {
      return url || require("@/assets/no-image.jpg");
    },


  },

 
  mounted(){

    // this.$store.dispatch(FETCH_AUTH_INFO).then(()=>{
        this.form = { ...this.authUser };
    // if (this.authUser.imageUrl)  this.form.imageUrl = `${this.authUser.imageUrl}`;


    // })

  }
};
</script>
